import React from 'react'
import string from './string_representation.jpg'
const String = () => {
    return (
        <div className='container'>
            <h1>String</h1>
            <p>
            Strings are actually one-dimensional array of characters terminated by a null character '\0'. Thus a null-terminated string contains the characters that comprise the string followed by a null. <br />
<br />
The following declaration and initialization create a string consisting of the word "Hello". To hold the null character at the end of the array, the size of the character array containing the string is one more than the number of characters in the word "Hello." <br />
char greeting[6] = &#123;'H', 'e', 'l', 'l', 'o', '\0'&#125;; <br />
If you follow the rule of array initialization then you can write the above statement as follows − <br />
<br />
char greeting[] = "Hello"; <br />

            </p>
            <img src={string} alt="" />
            <div className='containers'>
           <code className='library'>#include</code>  &lt;stdio.h&gt; <br/>
<br/>
<code className='keywords'>int</code> main () &123;<br/>
<br/>
<code className='keywords'> char</code> greeting[6] = &123;'H', 'e', 'l', 'l', 'o', '\0'&125;;<br/>
<code className='library'> printf</code>("Hello NooBies %s\n", greeting );<br/>
<code className='library'> return </code>0;<br/>
&125;<br/>
            </div>
            <table>
<tbody><tr>
<th>Sr.No.</th>
<th >Function <pre>{`&amp;`}</pre> Purpose</th>
</tr>
<tr>
<td class="ts">1</td>
<td><p><b>strcpy(s1, s2);</b></p>
<p>Copies string s2 into string s1.</p>
</td>
</tr>
<tr>
<td class="ts">2</td>
<td><p><b>strcat(s1, s2);</b></p>
<p>Concatenates string s2 onto the end of string s1.</p>
</td>
</tr>
<tr>
<td class="ts">3</td>
<td><p><b>strlen(s1);</b></p>
<p>Returns the length of string s1.</p>
</td>
</tr>
<tr>
<td class="ts">4</td>
<td><p><b>strcmp(s1, s2);</b></p>
<p>Returns 0 if s1 and s2 are the same; less than 0 if s1&lt;s2; greater than 0 if s1&gt;s2.</p>
</td>
</tr>
<tr>
<td class="ts">5</td>
<td><p><b>strchr(s1, ch);</b></p>
<p>Returns a pointer to the first occurrence of character ch in string s1.</p>
</td>
</tr>
<tr>
<td class="ts">6</td>
<td><p><b>strstr(s1, s2);</b></p>
<p>Returns a pointer to the first occurrence of string s2 in string s1.</p>
</td>
</tr>
</tbody></table>
        </div>
    )
}

export default String
